import { render, staticRenderFns } from "./fenxiang.vue?vue&type=template&id=39dd6504&scoped=true"
import script from "./fenxiang.vue?vue&type=script&lang=js"
export * from "./fenxiang.vue?vue&type=script&lang=js"
import style0 from "./fenxiang.vue?vue&type=style&index=0&id=39dd6504&prod&lang=css"
import style1 from "./fenxiang.vue?vue&type=style&index=1&id=39dd6504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dd6504",
  null
  
)

export default component.exports